import React from "react";
import NutritionHistoryTableRow from "./NutritionHistoryTableRow";

import {
  getNutritionData,
  getNutritionPlan,
  getTargetData,
} from "../../../../utils/nutrition-helpers";

const NutritionHistoryTable = ({
  units,
  nutritionHistory,
  handleActiveDayChange,
  activeDayUtc,
  isActiveDayPeriod,
  nutritionPlans,
  isCheckIn = false,
  activeExercises,
}) => {
  return (
    <section role="table-wrapper" className="nutrition-table" data-scrollable>
      <table role="report-table">
        <thead>
          <tr className="top-header">
            <th colSpan={1}>
              <span></span>
            </th>
            <th colSpan={5}>
              <span className="clipped">Target</span>
            </th>
            <th colSpan={5}>
              <span className="clipped">Consumed</span>
            </th>
            <th colSpan={5}>
              <span className="clipped">Adherence</span>
            </th>
            {!isCheckIn && <th colSpan={4}></th>}
          </tr>

          <BottomRown units={units} isCheckIn={isCheckIn} />
        </thead>
        <tbody>
          {nutritionHistory.map(
            ({
              nutrients,
              utcDate,
              hasWorkout,
              steps,
              bodyWeight,
              bodyWeightDays,
              isPeriod,
              startOfWeek,
              endOfWeek,
              nutrientsDays,
              proteinsDays,
              fatsDays,
              carbsDays,
              fibersDays,
              stepsDays,
              sleep,
              isSingle,
              workoutDays,
            }) => {
              const nutritionPlan = getNutritionPlan(
                nutritionPlans,
                utcDate,
                isPeriod,
                startOfWeek,
                endOfWeek
              );

              const nutritionData = getNutritionData(
                nutrients,
                units,
                steps,
                isPeriod,
                bodyWeight,
                bodyWeightDays,
                nutrientsDays,
                stepsDays,
                sleep,
                proteinsDays,
                carbsDays,
                fatsDays,
                fibersDays
              );

              const targetData = getTargetData({
                nutritionPlan,
                isPeriod,
                startOfWeek,
                endOfWeek,
                averageValues: true,
                hasWorkout,
                workoutDays,
                activeExercises,
              });

              // Condition so it doesn't show days where the user just uploaded body pictures or other stats like that
              const showRow =
                Boolean(nutritionData.kcal) ||
                Boolean(nutritionData.steps) ||
                Boolean(nutritionData.convertedBodyWeight) ||
                isPeriod;

              return (
                showRow && (
                  <NutritionHistoryTableRow
                    key={`${utcDate}-${nutritionData.kcal}-${
                      isPeriod || false
                    }`}
                    activeDayUtc={activeDayUtc}
                    handleActiveDayChange={handleActiveDayChange}
                    hasWorkout={hasWorkout}
                    utcDate={utcDate}
                    targetData={targetData}
                    nutritionData={nutritionData}
                    startOfWeek={startOfWeek}
                    endOfWeek={endOfWeek}
                    isActiveDayPeriod={isActiveDayPeriod}
                    isCheckIn={isCheckIn}
                    isSingle={isSingle}
                  />
                )
              );
            }
          )}
        </tbody>
      </table>
    </section>
  );
};

const BottomRown = ({ units, isCheckIn }) => (
  <tr>
    {/* Used br because using word-wrap or other css properties with tables don't work */}
    <th>Date</th>
    <th className="protein">
      Protein
      <br />
      <p className="st1">(g)</p>
    </th>
    <th className="carbs">
      Carbs
      <br />
      <p className="st1">(g)</p>
    </th>
    <th className="fat">
      Fat
      <br />
      <p className="st1">(g)</p>
    </th>
    <th>
      Fiber
      <br />
      <p className="st1">(g)</p>
    </th>
    <th>
      kCal
      <br />
      <p className="st1"></p>
    </th>
    <th className="protein">
      Protein
      <br />
      <p className="st1">(g)</p>
    </th>
    <th className="carbs">
      Carbs
      <br />
      <p className="st1">(g)</p>
    </th>
    <th className="fat">
      Fat
      <br />
      <p className="st1">(g)</p>
    </th>
    <th>
      Fiber
      <br />
      <p className="st1">(g)</p>
    </th>
    <th>kCal</th>
    <th className="protein">
      Protein
      <br />
      <p className="st1">(g)</p>
    </th>
    <th className="carbs">
      Carbs
      <br />
      <p className="st1">(g)</p>
    </th>
    <th className="fat">
      Fat
      <br />
      <p className="st1">(g)</p>
    </th>
    <th>
      Fiber
      <br />
      <p className="st1">(g)</p>
    </th>
    <th>kCal</th>
    {!isCheckIn && (
      <>
        <th>
          Bodyweight
          <br />
          <span>{units === "metric" ? "(Kg)" : "(Lbs)"}</span>
        </th>
        <th>Steps</th>
        <th>Sleep</th>
        <th>Workout</th>
      </>
    )}
  </tr>
);

export default NutritionHistoryTable;
